import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PendingEventsService } from '../services/pending-events.service';

@Component({
  selector: 'app-pendingevents',
  templateUrl: './pendingevents.component.html',
  styleUrls: ['./pendingevents.component.scss']
})
export class PendingeventsComponent implements OnInit {


  cancellationReason: boolean;
  submitted = false;
  cancellationReasonForm: FormGroup;
  allPendingEvents:any;
  sortForm:FormGroup;
  message:FormGroup;
  modifiedArray:any = [];
  cancellationArray:any = [];


  constructor(private pendingEvents: PendingEventsService,
    private formBuilder:FormBuilder) { }

  ngOnInit(): void {
    this.sortForm = this.formBuilder.group({
      sort:null
    })
    this.message = this.formBuilder.group({
      message:null
    })
    this.pendingEvents.getAllPendingEvents().then((res:any) => {
      console.log(res);
      this.allPendingEvents=res.events.data;
      for (let i=0; i<this.allPendingEvents.length; i++){
        if ((this.allPendingEvents[i].min_fee == 0) && (this.allPendingEvents[i].max_fee == 0)){
          this.allPendingEvents[i].freeEvent = "Free"
        } else if ((this.allPendingEvents[i].min_fee != 0 && this.allPendingEvents[i].min_fee != null) && (this.allPendingEvents[i].max_fee != 0 && this.allPendingEvents[i].max_fee != null)){
          this.allPendingEvents[i].freeEvent = "Paid"
        }
      }
    }).catch((err) =>{
      console.log(err);
    })
  }

  showCancellation(id) {
    this.cancellationReason = true;
    this.cancellationArray.id = id;
    console.log(this.cancellationArray.id)

  }

  hideCancellation() {
    this.cancellationReason = false;
    this.submitted = false;
    this.cancellationReasonForm.reset();
  }


acceptEvent(id) {
  this.pendingEvents.modifyEventStatus(id, "approved").then((res) => {
    console.log(res);
    for (let i=0; i<this.allPendingEvents.length; i++) {
      if (this.allPendingEvents[i].id === id){
        this.allPendingEvents.splice(i,1);
      }
    }

  })
}

rejectEvent() {
  this.pendingEvents.modifyEventStatus(this.cancellationArray.id, "rejected").then((res) => {
    console.log(res);
    for (let i=0; i<this.allPendingEvents.length; i++) {
      if (this.allPendingEvents[i].id === this.cancellationArray.id){
        this.allPendingEvents.splice(i,1);
      }
    }
    this.cancellationReason = false;
  })
}

saveEvent(el){
  localStorage.setItem("eventDetails", JSON.stringify(el))
}
}
